var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (features, featuresByTag, planHighlighting, plans, sortTags) {pug_html = pug_html + "\u003Cdiv class=\"features-table-cont\"\u003E\u003Cdiv class=\"features-divisions-outer\"\u003E\u003Cdiv class=\"features-divisions\"\u003E\u003Cdiv class=\"division dummy-div\"\u003E\u003C\u002Fdiv\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var plan = $$obj[pug_index0];
var activePlan = plan.isSomeByKey(planHighlighting) ? 'active' : '';
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["division","js-plan-name","plan-name",[plan.custom ? 'custom' : '', plan.plan.toLowerCase(), activePlan ]], [false,false,false,true]), false, true)+pug.attr("data-plan", plan.plan.toLowerCase(), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = plan.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index0];
var activePlan = plan.isSomeByKey(planHighlighting) ? 'active' : '';
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["division","js-plan-name","plan-name",[plan.custom ? 'custom' : '', plan.plan.toLowerCase(), activePlan ]], [false,false,false,true]), false, true)+pug.attr("data-plan", plan.plan.toLowerCase(), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = plan.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ctable class=\"features-table\"\u003E";
// iterate features.groupByTags().sort(sortTags).groups
;(function(){
  var $$obj = features.groupByTags().sort(sortTags).groups;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var group = $$obj[pug_index1];
featuresByTag = group.features
if ((group.key)) {
pug_html = pug_html + "\u003Ctr class=\"feature-row header-row js-tag\"\u003E\u003Ctd" + (pug.attr("colspan", plans.length + 1, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = group.key) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
// iterate featuresByTag.models
;(function(){
  var $$obj = featuresByTag.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var plan = $$obj[pug_index3];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index3];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var plan = $$obj[pug_index4];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index4];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var group = $$obj[pug_index1];
featuresByTag = group.features
if ((group.key)) {
pug_html = pug_html + "\u003Ctr class=\"feature-row header-row js-tag\"\u003E\u003Ctd" + (pug.attr("colspan", plans.length + 1, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = group.key) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
// iterate featuresByTag.models
;(function(){
  var $$obj = featuresByTag.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var feature = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var plan = $$obj[pug_index6];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index6];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var feature = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes(["js-feature","feature-row",plans.isFeatureLimitedInAnyPlan(feature) ? 'limited-in-some-plans' : ''], [false,false,true]), false, true)) + "\u003E\u003Ctd\u003E";
var featureProperties = feature.consolidatePropertiesForPlans(plans.models, 'friendlyName')
pug_html = pug_html + "\u003Cdiv" + (" class=\"cell-content\""+" data-toggle=\"tooltip\" data-placement=\"right\""+pug.attr("title", featureProperties[0].description, true, true)+" data-container=\".features-table\"") + "\u003E";
var names = featureProperties.map(function(fp) { return fp.friendlyName; })
if (featureProperties[0].link) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", featureProperties[0].link, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = names.join(' / ')) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (featureProperties[0].description) {
pug_html = pug_html + "\u003Cspan class=\"tip-icon\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
// iterate plans.models
;(function(){
  var $$obj = plans.models;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var plan = $$obj[pug_index7];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var plan = $$obj[pug_index7];
var planFeature = plan.getPlanFeature(feature);
var classes = []
classes.push(plan.custom ? 'custom js-custom' : '')
classes.push(planFeature ? 'present js-present' : '')
classes.push(planFeature && planFeature.hasDescription() ? 'has-limit js-has-limit' : '')
pug_html = pug_html + "\u003Ctd" + (pug.attr("class", pug.classes(["js-plan-feature","feature",classes], [false,false,true]), false, true)+pug.attr("data-plan-key", plan.plan, true, true)+pug.attr("data-feature-key", feature.key, true, true)) + "\u003E";
if (planFeature) {
if (planFeature.hasDescription()) {
pug_html = pug_html + (pug.escape(null == (pug_interp = planFeature.getDescription()) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Cspan class=\"check-icon\"\u003E\u003C\u002Fspan\u003E";
}
}
else {
pug_html = pug_html + "\u003Cspan\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E";}.call(this,"features" in locals_for_with?locals_for_with.features:typeof features!=="undefined"?features:undefined,"featuresByTag" in locals_for_with?locals_for_with.featuresByTag:typeof featuresByTag!=="undefined"?featuresByTag:undefined,"planHighlighting" in locals_for_with?locals_for_with.planHighlighting:typeof planHighlighting!=="undefined"?planHighlighting:undefined,"plans" in locals_for_with?locals_for_with.plans:typeof plans!=="undefined"?plans:undefined,"sortTags" in locals_for_with?locals_for_with.sortTags:typeof sortTags!=="undefined"?sortTags:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/pricing/partials/features/features-table.pug
// module id = 973
// module chunks = 0